// src/pages/Terms.js
import React from "react";
import "../App.css";

const Terms = () => {
  return (
    <section className="legal-page">
      <header className="legal-hero">
        <h1 className="legal-hero-title">Terms of Use</h1>
        <p className="legal-hero-subtitle">
          Please read these terms carefully before using Ndils Daily Care’s
          website and services.
        </p>
        <p className="legal-meta">Last updated: November 2025 • United Kingdom</p>
      </header>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using this website, you agree to be bound by these
            Terms of Use and all applicable laws and regulations. If you do not
            agree, please do not use this website.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Our Services</h2>
          <p>
            Ndils Daily Care provides domiciliary and community-based care
            services. Information on this website is for general guidance and
            does not replace a personalised care assessment or professional
            advice.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Use of the Website</h2>
          <ul className="legal-list">
            <li>You agree not to misuse, disrupt, or damage the website.</li>
            <li>
              You must not attempt to gain unauthorised access to any part of
              the site, server or any data.
            </li>
            <li>
              You agree not to use the website for any unlawful or fraudulent
              purpose.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Appointments & Enquiries</h2>
          <p>
            Any care enquiries or booking requests submitted through this
            website are not guaranteed until confirmed in writing by Ndils Daily
            Care. We may contact you to clarify details and suitability.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Intellectual Property</h2>
          <p>
            All content, branding, text, graphics and layout on this website are
            owned by or licensed to Ndils Daily Care. You may not copy,
            reproduce or distribute any part of this site without prior written
            permission.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Limitation of Liability</h2>
          <p>
            While we aim to keep information accurate and up to date, we make no
            guarantees about completeness or suitability. Ndils Daily Care will
            not be liable for any loss arising from reliance on information
            provided on this website.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Changes to These Terms</h2>
          <p>
            We may update these Terms of Use from time to time. Any changes will
            be posted on this page with an updated “Last updated” date.
          </p>
        </section>
      </div>
    </section>
  );
};

export default Terms;
